import React from 'react';
import Metadata from '@components-clean/core/metadata';

const MetadataPage = () => {
    const dataItem = {
        recordId: '0123456789',
        createdDate: new Date(2024, 1, 1),
        createdBy: 'Tom Smith',
        updatedDate: new Date(2024, 1, 1),
        updatedBy: 'Tom Smith',
        configId: '0123456789',
    };

    const dataItemLongName = {
        recordId: '0123456789',
        createdDate: new Date(2024, 1, 1),
        createdBy:
            'abcdefghfjabcdefghfjabcdefghfjabcdefghfjabcdefghfj abcdefghfjabcdefghfjabcdefghfjabcdefghfjabcdefghfj',
        updatedDate: new Date(2024, 1, 1),
        updatedBy:
            'abcdefghfjabcdefghfjabcdefghfjabcdefghfjabcdefghfj abcdefghfjabcdefghfjabcdefghfjabcdefghfjabcdefghfj',
        configId: '0123456789',
    };

    return (
        <>
            <h2>Mata Data Page</h2>
            <div>
                <div>
                    <p> Bottom </p>
                    <Metadata position="bottom" area="Study" dataItem={dataItem} data-testid="metadata-datatest-id" />
                </div>
            </div>
            <div>
                <div>
                    <p> Left </p>
                    <Metadata position="left" area="Study" dataItem={dataItem} data-testid="metadata-datatest-id" />
                </div>
            </div>
            <div>
                <div>
                    <p> Right </p>
                    <Metadata position="right" area="Study" dataItem={dataItem} data-testid="metadata-datatest-id" />
                </div>
            </div>
            <div>
                <div>
                    <p> Top </p>
                    <Metadata position="top" area="Study" dataItem={dataItem} data-testid="metadata-datatest-id" />
                </div>
            </div>
            <div>
                <div>
                    <p> Long Name </p>
                    <Metadata
                        position="right"
                        area="Study"
                        dataItem={dataItemLongName}
                        data-testid="metadata-datatest-id"
                    />
                </div>
            </div>
        </>
    );
};

export default MetadataPage;
